import { E as t } from "./lit-element-CwWchyls.js";
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const p = (r) => r != null ? r : t;
export {
  p as o
};
